import { FiltersBar, SearchInput, useFilterUpdate } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

import { CarrierFilter } from './carrier-filter';
import { FilterDrawer } from './filter-drawer';
import { StatusFilter } from './status-filter';
import { useShipmentListFilter } from './useShipmentListFilter';

export function Filters() {
  const { filtering, advancedFiltering, setFiltering, setAdvancedFiltering, clearAdvancedFilters } =
    useShipmentListFilter();
  const { t } = useTranslation();

  useFilterUpdate('search', filtering.search);
  useFilterUpdate('group', filtering.group);

  return (
    <FiltersBar.Row>
      <SearchInput
        placeholder={t('shipments.list.searchPlaceholder')}
        onChange={v => setFiltering(p => ({ ...p, search: v }))}
        defaultValue={filtering.search}
      />

      <FiltersBar.Toolbar>
        <StatusFilter
          onChange={statuses => setFiltering(p => ({ ...p, group: 'ALL', statuses }))}
          value={filtering.statuses}
        />

        <CarrierFilter onChange={carriers => setFiltering(p => ({ ...p, carriers }))} value={filtering.carriers} />
        <FilterDrawer defaultValue={advancedFiltering} onSubmit={setAdvancedFiltering} onReset={clearAdvancedFilters} />
      </FiltersBar.Toolbar>
    </FiltersBar.Row>
  );
}
